import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * This updates based on the currently set language
 * We'll need this for most urls that go outside of the SPA
 *
 * If we add many languages this may not scale well but should work
 * for the moment
 */
export const useValueBasedOnLanguage = <T extends unknown>(
  englishValue: T,
  spanishValue: T
) => {
  const { i18n } = useTranslation()
  const [value, setValue] = useState(englishValue)

  useEffect(() => {
    if (i18n.language === 'en') {
      setValue(englishValue)
    } else {
      setValue(spanishValue)
    }
  }, [setValue, i18n.language, englishValue, spanishValue])

  return value
}
